import { useQuery } from "@tanstack/vue-query";
import type { SearchApiV2SearchProductsGetRequest } from "mws-ts-v2-sdk";

import { queries } from "~/queries";

export default function useSearchProductPreview(
  searchTerm: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean>,
) {
  const platformStore = usePlatformStore();
  const productsQueryParams = computed<SearchApiV2SearchProductsGetRequest>(
    () => ({
      xPlatformKey: platformStore.getPlatformConfiguration.platformId,
      pageSize: 4,
      searchTerm: toValue(searchTerm),
    }),
  );

  const { data: products } = useQuery({
    ...queries.search.products(productsQueryParams),
    enabled,
  });

  const showNoResultsPlaceholder = computed(() =>
    Boolean(
      toValue(enabled) && products.value && products.value.resultCount === 0,
    ),
  );

  return {
    products,
    showNoResultsPlaceholder,
  };
}
